import React from 'react';
import { RiFileList3Line } from 'react-icons/ri';
import { SUBMODULOS_FISCAL } from '../../../components/sidebar/submodulos';
import { HubDoModulo } from '../HubDoModulo';

/** Hub do Fiscal no padrão do Contábil: cartões em vidro + submódulos no menu lateral. */
export function modulesHomeSupervisorPage() {
  return (
    <HubDoModulo
      nome="Fiscal"
      descricao="Acompanhamento por regime (Simples Nacional, Lucro Presumido e Lucro Real), impostos sobre o faturamento, agentes de auditoria, ICMS e emissão de NFS-e."
      cor="#DFF3FF"
      icone={<RiFileList3Line size={32} color="#008CCC" />}
      submodulos={SUBMODULOS_FISCAL}
    />
  );
}
